import { render, staticRenderFns } from "./CiButtonSetWrapper.vue?vue&type=template&id=4ca7d787&"
import script from "./CiButtonSetWrapper.vue?vue&type=script&lang=js&"
export * from "./CiButtonSetWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports